var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"print-card",attrs:{"elevation":"0"}},[_c('v-card-text',[_c(_vm.previewComponent,{tag:"component",attrs:{"article":_vm.article,"show_ids":_vm.show_ids,"show_lines":_vm.show_lines}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }